module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cash-steps",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('div', {
    staticClass: "cash-steps-box"
  }, _vm._l((_vm.steps), function(step, $i) {
    return _c('div', {
      staticClass: "cash-steps-item",
      class: {
        'is-current': step.current, 'is-disable': step.disable
      }
    }, [_c('span', {
      staticClass: "cash-steps-icon"
    }, [_c('w-icon', {
      attrs: {
        "width": 16,
        "height": 16,
        "fill": step.current ? '#fff' : '#c0c0c0',
        "type": step.iconName
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "cash-steps-label"
    }, [_vm._v(_vm._s(step.text))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cash-steps-line-box"
  }, _vm._l((_vm.steps.length), function($i) {
    return ($i < _vm.steps.length) ? _c('span', {
      staticClass: "cash-steps-line",
      class: {
        'is-current': _vm.steps[$i].current, 'is-disable': _vm.steps[$i].disable
      },
      style: (_vm.lineStyle($i))
    }) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3241fc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/components/steps.vue
// module id = 250
// module chunks = 93